// export const DGTL_BACKEND_URL = "http://localhost:5000";
//commented

// Dynamic function to get the backend URL based on current environment
export const getDGTLBackendURL = () => {
  const envrioment =
    localStorage.getItem("envrioment") ||
    window.location.href.split("&env=")[1]?.split("&")[0] ||
    window.location.search.split("env=")[1]?.split("&")[0];

  if (envrioment === "staging") {
    return "https://staging.digitaldeposits.app";
  } else if (envrioment === "clients") {
    return "https://clients.digitaldeposits.app";
  } else if (envrioment === "local") {
    return "http://localhost:8000";
  } else if (envrioment === "cbl") {
    return "https://dgtl.concordebb.com";
  } else if (envrioment === "devcbl") {
    return "https://dev.concordebb.com";
  } else if (envrioment === "devnccu") {
    return "https://nccudev.dgtlbanking.com";
  }
  return "";
};

// Keep the static export for backward compatibility
let envrioment =
  localStorage.getItem("envrioment") ||
  window.location.href.split("&env=")[1] ||
  window.location.search.split("env=")[1];
export let DGTL_BACKEND_URL = "";
export const RISK_ENGINE_BACKEND_URL = "https://risk.dgtlbanking.com/api";
if (envrioment == "staging") {
  DGTL_BACKEND_URL = "https://staging.digitaldeposits.app";
} else if (envrioment == "clients") {
  DGTL_BACKEND_URL = "https://clients.digitaldeposits.app";
} else if (envrioment == "local") {
  DGTL_BACKEND_URL = "http://localhost:8000";
} else if (envrioment == "cbl") {
  DGTL_BACKEND_URL = "https://dgtl.concordebb.com";
} else if (envrioment == "devcbl") {
  DGTL_BACKEND_URL = "https://dev.concordebb.com";
} else if (envrioment == "devnccu") {
  DGTL_BACKEND_URL = "https://nccudev.dgtlbanking.com";
}
// export const DGTL_BACKEND_URL = "https://clients.digitaldeposits.app";
// export const DGTL_BACKEND_URL = "http://localhost:5000";
// export const DGTL_BACKEND_URL = "https://risk-engine-be.vercel.app";

export const REACT_APP_RISK_ENGINE_URL = "http://localhost:3001";
